import { defineComponent as _defineComponent } from 'vue'
import { CandidateDashboardStatsGetters } from '@tokyojob/core'
import { IconSize } from '@tokyojob/frontend-components'
import { CIconFactory, CIcon } from '@tokyojob/frontend-components'
import { ref, watch } from 'vue'
import { getAppStore } from '~/store/app.store'


export default /*#__PURE__*/_defineComponent({
  __name: 'c-floating-notifications.component',
  setup(__props) {

const appStore = getAppStore()
const stats = appStore.dashboardStats

const hasNewMessages = ref(CandidateDashboardStatsGetters.hasNewMessages(stats))
const newMessages = ref(stats?.newMessages)
const messagesIcon = CIconFactory.Icon({ icon: 'message', size: IconSize.medium, classes: 'color-green-dark2' })

watch(
  () => appStore.dashboardStats,
  (newVal) => {
    hasNewMessages.value = CandidateDashboardStatsGetters.hasNewMessages(newVal)
    newMessages.value = newVal?.newMessages
  }
)

return { __sfc: true,appStore, stats, hasNewMessages, newMessages, messagesIcon, CIcon }
}

})